import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./ElementPlaceholder.module.less";

const ElementPlaceholder = ({ className, ...rest }) => {
  return (
    <div
      className={classNames(styles.elementPlaceholder, className)}
      data-testid="task-item-column-placeholder"
      {...rest}
    />
  );
};

ElementPlaceholder.propTypes = {
  className: PropTypes.string,
};

export default ElementPlaceholder;
